import "../components/select";
import { changeEvent } from "../components/select";

let filters;
let filtersAndValues = {};

document.addEventListener("DOMContentLoaded", function () {
  filters = document.querySelectorAll(".js-event-filter");

  filters.forEach((filter) => {
    const name = filter.dataset.name;
    const value = filter.dataset.value;
    filtersAndValues[name] = value;

    filter.addEventListener("change", changeFilterHandler);
  });

  hideEmptyMonths();
  useUrlGetParams();
});

function changeFilterHandler(e) {
  const name = e.target.dataset.name;
  const value = e.target.dataset.value;

  filtersAndValues[name] = value;

  filterEvents();
  setUrlGetParams();
}

function filterEvents() {
  const events = document.querySelectorAll(".events-event");
  events.forEach((event) => {
    event.classList.remove("d-none");
  });

  for (const filter in filtersAndValues) {
    // Проверка на то, что поле не у наследованных
    if (!Object.hasOwnProperty.call(filtersAndValues, filter)) {
      continue;
    }

    const filterValue = filtersAndValues[filter];

    events.forEach((event) => {
      const hasValue = event.dataset[filter]
        .split(" ")
        .map((e) => e.trim())
        .includes(filterValue);

      if (!(hasValue || !filterValue || filterValue.length === 0)) {
        event.classList.add("d-none");
      }
    });
  }

  hideEmptyMonths();
}

function hideEmptyMonths() {
  const months = document.querySelectorAll(".events-month");

  let allMonthsHidden = true;

  months.forEach((month) => {
    month.classList.remove("d-none");

    const events = month.querySelectorAll(".events-event");
    let allEventsHidden = true;

    events.forEach((event) => {
      if (!event.classList.contains("d-none")) {
        allEventsHidden = false;
      }
    });

    if (allEventsHidden) {
      month.classList.add("d-none");
    } else {
      allMonthsHidden = false;
    }
  });

  const noData = document.querySelector(".events-no-data");
  if (allMonthsHidden) {
    noData.classList.remove("d-none");
  } else {
    noData.classList.add("d-none");
  }
}

function setUrlGetParams() {
  const currentLocation = window.location.href;
  const url = new URL(currentLocation);
  const getParams = url.searchParams;

  let isEmptyValues = true;
  for (const filter in filtersAndValues) {
    if (!Object.hasOwnProperty.call(filtersAndValues, filter)) {
      continue;
    }

    const filterValue = filtersAndValues[filter];

    if (filterValue.length) {
      isEmptyValues = false;
    }

    getParams.set(filter, filterValue);
  }

  if (isEmptyValues) {
    url.search = "";
  } else {
    url.search = getParams.toString();
  }

  history.pushState(filtersAndValues, "", url);
}

function useUrlGetParams() {
  const currentLocation = window.location.href;
  const url = new URL(currentLocation);
  const getParams = url.searchParams;

  for (const filter in filtersAndValues) {
    if (!Object.hasOwnProperty.call(filtersAndValues, filter)) {
      continue;
    }

    const getParamValue = getParams.get(filter) || "";
    filtersAndValues[filter] = getParamValue;
  }

  setFiltersValues();
}

function setFiltersValues() {
  filters.forEach((filter) => {
    const name = filter.dataset.name;
    filter.dataset.value = filtersAndValues[name];

    filter.dispatchEvent(changeEvent);
  });
}
